import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard";

//Icon pages
import RemixIcons from "../pages/Icons/RemixIcons/RemixIcons";
import BoxIcons from "../pages/Icons/BoxIcons/BoxIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign/MaterialDesign";
import FeatherIcons from "../pages/Icons/FeatherIcons/FeatherIcons";
import LineAwesomeIcons from "../pages/Icons/LineAwesomeIcons/LineAwesomeIcons";

//login
import Login from "../pages/Authentication/Login";
import ForgotPassword from "../pages/Authentication/ForgotPssword";
import ResetPassword from "../pages/Authentication/ResetPassword";
import Register from "../pages/Authentication/Register";
import Logout from "../pages/Authentication/Logout";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

import VerifyOtp from "../pages/Authentication/VerifyOtp";
import InRealTime from "../pages/InRealTime";

import Maintenance from "../pages/Maintenance";
import VehicleManagement from "../pages/VehicleManagement";
import UserManagement from "../pages/UserManagement";
import UserPermissions from "../pages/UserPermissions";
import AddPermission from "../pages/UserPermissions/addUserPermission";
import SalaryManagement from "../pages/SalaryManagement";
import DashboardAccounting from "../pages/AccountDashboard";
import TripList from "../pages/Trips/TripList";
import TripDetail from "../pages/Trips/TripList/TripDetails";
import { MapView } from "../pages/MapView/MapView";
import DriverManagement from "../pages/DriverManagement";
import Category from "../pages/Category";
import VehicleDetail from "../pages/VehicleManagement/vehicleDetail/VehicleDetail";

const authProtectedRoutes = [
  { path: "/index", component: <Dashboard /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/accounting-dashboard", component: <DashboardAccounting /> },

  { path: "/real-time", component: <InRealTime /> },
  { path: "/trip-list", component: <TripList /> },
  { path: "/trip-details/:id", component: <TripDetail /> },
  { path: "/map-view", component: <MapView /> },
  { path: "/maintenance", component: <Maintenance /> },
  { path: "/vehicle-management", component: <VehicleManagement /> },
  { path: "/vehicle-details/:id", component: <VehicleDetail /> },
  { path: "/user-management", component: <UserManagement /> },
  { path: "/user-permissions", component: <UserPermissions /> },
  { path: "/add-permissions/:id", component: <AddPermission /> },
  { path: "/add-permissions", component: <AddPermission /> },
  { path: "/salary-management", component: <SalaryManagement /> },
  { path: "/driver-management", component: <DriverManagement /> },
  { path: "/category", component: <Category /> },

  //Icons
  { path: "/icons-remix", component: <RemixIcons /> },
  { path: "/icons-boxicons", component: <BoxIcons /> },
  { path: "/icons-materialdesign", component: <MaterialDesign /> },
  { path: "/icons-feather", component: <FeatherIcons /> },
  { path: "/icons-lineawesome", component: <LineAwesomeIcons /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/verify-code", component: <VerifyOtp /> },
  { path: "/logout", component: <Logout /> },
];

export { authProtectedRoutes, publicRoutes };
